import React from 'react';

//styles
import { Loader, LoaderParts, LoaderWrapper } from './index.styled';

const ButtonLoader = () => (
  <LoaderWrapper>
    <Loader>
      <LoaderParts />
      <LoaderParts />
      <LoaderParts />
    </Loader>
  </LoaderWrapper>
);

export default ButtonLoader;
